'use client';

import PageTab from '@pc/components/molecules/tab/PageTab';
import PageTabsContainer from '@pc/components/molecules/tab/PageTabsContainer';
import { useRouter } from 'next/navigation';

function PolicyRightsTabs() {
  const router = useRouter();
  return (
    <PageTabsContainer className='h-[unset] w-[1440px]' contentClassName='flex justify-start w-[1440px]'>
      <PageTab includedURLPath='/policy/rights/intro' onClick={() => router.push('/policy/rights/intro')} isMiddleLine>
        센터소개
      </PageTab>
      <PageTab
        includedURLPath='/policy/rights/process'
        onClick={() => router.push('/policy/rights/process')}
        isMiddleLine
      >
        처리절차
      </PageTab>
    </PageTabsContainer>
  );
}

export default PolicyRightsTabs;
